import { Grid, Button, Accordion, AccordionSummary, AccordionDetails } from "@material-ui/core";
import { Add, ExpandMore as ExpandMoreIcon } from "@material-ui/icons";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { IReduxAppState } from "../../reducers";

import ICommonFormProps from "../../yoello-lib/modules/dynamicForms/interfaces/ICommonFormProps";
import FormAlongsideText from "../../yoello-lib/modules/dynamicForms/FormComponents/FormAlongsideText";
import { useStyles } from "./ui/styles";
import { useVenueAreas } from "./useVenueAreas";
import VenueAreaToolbar from "./ui/VenueAreaToolbar";
import { initialState, IOrderLocationsGroup, VenueAreasRangesReducer } from "./state/venueAreas.reducer";
import { useMemo, useReducer, useState } from "react";
import { OrderLocations } from "./ui/OrderLocation";
import ListLoading from "../util/Loading";
import { AlertStatusCard } from "../../yoello-lib/modules/components/UI/Alerts/AlertStatusCard";
import { PERMISSIONS } from "../../const/permissions.const";
import useCheckPermissions from "../../hooks/useCheckPermissions";
import { DineInContainer, IDineInFormState } from "./DineInContainer";


export default function VenueAreasContainer(props: ICommonFormProps) {
  const classes: any = useStyles();
  const selectedVenueId = useSelector((state: IReduxAppState) => state.selectedVenueId)
  const settings = useSelector((state: IReduxAppState) => state.venue[selectedVenueId].venueSettings)
  const [dineInState, setDineInState] = useState<IDineInFormState>({
    table_enabled: settings?.table_enabled ?? false,
    min_dine_in_price: settings?.min_dine_in_price ?? 0
  });
  const { t } = useTranslation();
  const [state, dispatch] = useReducer(
    VenueAreasRangesReducer,
    initialState
  );
  const {
    handleVenueArea,
    onDeleteVenueArea,
    onOrderLocationCreate,
    updateVenueAreaRanges,
    onOrderLocationChange,
    onOrderLocationDelete,
    onStatusChangeHandler,
    updateTableServiceSetting,
    isLoading,
    error
  } = useVenueAreas(dispatch, props.formProps?.venue_group_id, dineInState, settings?.id);
  const { hasPermission } = useCheckPermissions(PERMISSIONS.ORDER_SETTINGS_MANAGEMENT);

  const disabled = useMemo(()=>{
    return (!props.formProps?.venue_group_id && 
    Object.values(state).length>0 && 
    Object.values(state)[0].group_override ) || !hasPermission
  // eslint-disable-next-line  
  },[props.formProps, state]);


  function renderLocations(group: IOrderLocationsGroup) {

    return <OrderLocations
      onChangeHandler={(e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>, locationId: string) => onOrderLocationChange(e, locationId, group)}
      onDeleteHandler={(locationId: string) => onOrderLocationDelete(locationId, group)}
      orderLocations={group.order_locations}
      onCreateHandler={() => onOrderLocationCreate(group)}
      error={error[group.id]}
    />
  }

  if (isLoading) {
    return <ListLoading />
  }
  
  return <>
    {!props.formProps?.venue_group_id && <DineInContainer state={dineInState} setState={setDineInState}/>}
    <Grid item xs={12}>
      <FormAlongsideText
        label={props.label}
        secondLabel={props.formProps?.secondLabel as string}
        secondLabelJSX={props.formProps?.secondLabelJSX}
      />
    </Grid>

    {disabled && <div className={classes.alert}>
      <AlertStatusCard
        alertProps={{ severity: "info" }}
        alertMessage={
          <>
            {t("groups.areas.info")}{" "}
            <b>
              {t("groups.areas.subInfo")}
            </b>
          </>
        }
      />
    </div>}

    {Object.values(state).map((group) => <Accordion defaultExpanded={group.isNewField} key={group.id} className={`${classes.root} ${error[group.id] && classes.error}`
    }>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1a-content"
        id="panel1a-header"
        disabled={disabled}
      >
        <VenueAreaToolbar
          {...group}
          onDelete={() => onDeleteVenueArea(group.id, Object.values(state))}
          onEdit={() => handleVenueArea(group)}
          onStatusChangeHandler = {(enabled) => onStatusChangeHandler(enabled, group)}
        />
      </AccordionSummary>
      <AccordionDetails>
        {renderLocations(group)}
      </AccordionDetails>
    </Accordion>)}

    < Grid item xs={12}>
      <Button
        data-component-name={"order-location-groups-extender-button"}
        onClick={() => handleVenueArea()}
        disabled={disabled}
        variant="outlined"
        className={disabled && classes.disabled}
        style={{ color: "#212121", borderColor: "#C1CAE1!important" }}> <Add style={{ paddingRight: "0.625rem", fontSize: "2rem" }} /> {t(props.formProps?.buttonLabel as string)}</Button>
    </Grid>


    < Grid item xs={12} style={{ marginTop: "3rem" }}>
      <Button
        data-component-name={"update-venue-area-ranges"}
        variant='contained'
        color='primary'
        onClick={() => disabled ? updateTableServiceSetting() : updateVenueAreaRanges(state)}
      >
        {t('forms.buttons.updateDineInOrder')}
      </Button>
    </Grid>

  </>;
}